var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coming-soon"},[_c('i',{staticClass:"el-icon-loading"}),_c('h2',[_vm._v("功能开发中，敬请期待...")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }